import {
  getIssueStatus,
  IssueStatusKenshin,
} from 'shared/constants/kenshin/issues';
import PropTypes from 'prop-types';

import intl from 'react-intl-universal';
import { Status } from '../styles';

export const ReceivedProgressColumn = () => {
  return {
    header: intl.get('kenshin_received_history_column_label_progress'),
    accessorKey: 'progress',
    size: 70,
    filterVariant: 'select',
    filterSelectOptions: [
      {
        label: intl.get('shared_value_status_new_task'),
        value: IssueStatusKenshin.NEWTASK,
      },
      {
        label: intl.get('shared_value_status_examining'),
        value: IssueStatusKenshin.DOCTORASSIGNED,
      },
      {
        label: intl.get('shared_value_status_report_ready'),
        value: IssueStatusKenshin.REPORTREADY,
      },
      {
        label: intl.get('shared_value_status_send_back_receiver'),
        value: IssueStatusKenshin.SENDBACK,
      },
      {
        label: intl.get('shared_value_status_done_receiver'),
        value: IssueStatusKenshin.DONE,
      },
    ],
    enableColumnFilter: true,
    enableColumnActions: false,
    // custom filter function
    filterFn: (row, id, filterValue) => {
      return row.getValue(id) === filterValue;
    },
    //custom conditional format and styling
    Cell: ({ renderedCellValue }) => {
      return progressCell({ renderedCellValue });
    },
  };
};

const progressCell = ({ renderedCellValue }) => {
  const progress = renderedCellValue;
  return <Status color={progress}>{getIssueStatus(progress)}</Status>;
};

progressCell.propTypes = {
  renderedCellValue: PropTypes.string.isRequired,
};

export const FromColumn = () => {
  return {
    header: intl.get('kenshin_received_history_column_label_from'),
    accessorKey: 'srcOrgName',
    size: 100,
    enableClickToCopy: true,
    enableColumnFilter: true,
    filterFn: 'fuzzy',
    filterVariant: 'text',
    enableColumnActions: false,
  };
};
